import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import Projects from './pages/Projects';
import About from './pages/About';
import Subscribe from './pages/Subscribe';
import Admin from './pages/Admin';
import { DataProvider } from './context/DataContext';
import { FiUser, FiX } from 'react-icons/fi';
import './styles/theme.css';
import './styles/App.css';

function MainLayout({ theme, toggleTheme }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const showSidebar = location.pathname === '/';

  return (
    <div className="app">
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <div className="app-body">
        {showSidebar && <Sidebar />}
        {showSidebar && mobileOpen && (
          <div className="mobile-sidebar-overlay open" onClick={() => setMobileOpen(false)}>
            <Sidebar className="mobile-open" />
          </div>
        )}
        <main className={`main-content${showSidebar ? '' : ' no-sidebar'}`}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/subscribe" element={<Subscribe />} />
          </Routes>
        </main>
      </div>
      <Footer />
      {showSidebar && (
        <button className="mobile-about-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <FiX /> : <FiUser />}
        </button>
      )}
    </div>
  );
}

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('twe-theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('twe-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));

  return (
    <DataProvider>
      <Router>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/*" element={<MainLayout theme={theme} toggleTheme={toggleTheme} />} />
        </Routes>
      </Router>
    </DataProvider>
  );
}

export default App;
